import React from 'react';
import {
  CartesianGrid, Label, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip,
  XAxis, YAxis,
} from 'recharts';
import { formatPriceFR } from '../../utils/formatFR';
import Bloc from './Bloc';
import { AXE, COULEUR_MARCHE, COULEUR_PORTEFEUILLE, GRILLE } from './couleurs';

const TITRES = { mois: 'Prix médian par mois', trimestre: 'Prix médian par trimestre',
  semestre: 'Prix médian par semestre' };
const AXES = { mois: 'Mois de publication', trimestre: 'Trimestre de publication',
  semestre: 'Semestre de publication' };

/** Courbe du prix médian + ligne orange du prix demandé (lot DI § 5). */
export const GraphiquePrix = ({ donnees, portefeuille, activiteChoisie, libelleActivite }) => {
  const { granularite = 'mois', points = [] } = donnees.courbe_prix || {};
  const prixDemande = portefeuille && activiteChoisie ? portefeuille.mediane_demandee : null;

  return (
    <Bloc
      titre={TITRES[granularite]}
      legende="Médiane des prix publiés ; un point est masqué sous 10 ventes."
      testid="observatoire-graph-prix"
    >
      <div className="h-64 -ml-2">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points} margin={{ top: 8, right: 8, bottom: 28, left: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={GRILLE} vertical={false} />
            <XAxis dataKey="libelle" tick={{ fontSize: 11, fill: AXE }}>
              <Label value={AXES[granularite]} position="insideBottom" offset={-18}
                     style={{ fontSize: 11, fill: AXE }} />
            </XAxis>
            <YAxis tick={{ fontSize: 11, fill: AXE }} width={86}
                   tickFormatter={(v) => formatPriceFR(v)}>
              <Label value="Prix médian (€)" angle={-90} position="insideLeft" offset={10}
                     style={{ fontSize: 11, fill: AXE, textAnchor: 'middle' }} />
            </YAxis>
            <Tooltip
              formatter={(valeur, nom, charge) => [
                `${formatPriceFR(valeur)} (${charge?.payload?.nombre || 0} ventes)`,
                'Prix médian (marché)',
              ]}
              contentStyle={{ fontSize: 12, borderRadius: 8 }}
            />
            <Legend verticalAlign="top" height={24} wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="mediane" name="Prix médian des ventes (€)"
                  stroke={COULEUR_MARCHE} strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 5 }} />
            {prixDemande ? (
              <ReferenceLine
                y={prixDemande}
                stroke={COULEUR_PORTEFEUILLE}
                strokeDasharray="6 4"
                strokeWidth={2}
                label={{ value: `Vos biens : ${formatPriceFR(prixDemande)}`, position: 'insideTopRight',
                  fill: COULEUR_PORTEFEUILLE, fontSize: 11 }}
              />
            ) : null}
          </LineChart>
        </ResponsiveContainer>
      </div>
      {portefeuille && !activiteChoisie && (
        <p className="text-xs text-slate-500 mt-2" data-testid="observatoire-graph-prix-note">
          Choisissez une activité pour comparer vos prix demandés aux prix de vente.
        </p>
      )}
      {prixDemande ? (
        <p className="text-xs mt-2 text-slate-600 flex items-center gap-1.5"
           data-testid="observatoire-graph-prix-portefeuille">
          <span className="inline-block w-2.5 h-2.5 rounded-sm shrink-0"
                style={{ backgroundColor: COULEUR_PORTEFEUILLE }}></span>
          Vos {libelleActivite} : prix médian demandé (€)
        </p>
      ) : null}
    </Bloc>
  );
};

export default GraphiquePrix;
